import { render, staticRenderFns } from "./FailedRequestEmail.vue?vue&type=template&id=c45a2d96&scoped=true&"
import script from "./FailedRequestEmail.vue?vue&type=script&lang=js&"
export * from "./FailedRequestEmail.vue?vue&type=script&lang=js&"
import style0 from "./FailedRequestEmail.vue?vue&type=style&index=0&id=c45a2d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45a2d96",
  null
  
)

export default component.exports